var urlUtil = require('../../lib/url.es6');
var Autogrow = require('autogrow');
var Connection = require('connection');
var HashDialogView = require('hashdialogview');
var NetworkEditor = require('networkeditor');
var OrgMember = require('orgmember');
var OrgMemberView = require('orgmemberview');
var PayViewMixins = require('payviewmixins');


var OrgDetailView = HashDialogView.extend($.extend({}, PayViewMixins, {
    el: '#orgDetailScreen',
    initialize: function (options) {
        this.session = options.session;
        this.dialog = options.dialog;
        this.formatter = this.dialog.formatter;
        this.dialog.bind('close', this.hide, this);

        this.visible = false;
        this.billingShown = false;

        this.returnLines = $('#orgDetailScreenReturn');

        this.billingInfo = $('#orgBillingInfo');
        this.billingLink = this.$('a.orgBilling');
        this.billingBackLink = this.$('.orgBillingBack');
        this.billingDetails = $('#orgBillingDetails');

        this.details = $('#orgDetails');

        this.detailVitals = $('#orgDetailVitals');
        this.detailName = this.$('.orgDetailName');
        this.detailBorn = $('#orgDetailBorn');
        this.detailBillingEmail = $('#orgDetailBillingEmail');
        this.detailBillingEmailRow = $('#orgDetailBillingEmailRow');
        this.detailVatCountry = $('#orgDetailVatCountry');
        this.detailVatNumber = $('#orgDetailVatNumber');
        this.detailVatRow = $('#orgDetailVatRow');
        this.detailVatExplanation = $('#orgDetailVatExplanation');

        this.manageLinks = $('#orgManageLinks');
        this.deleteLink = $('#orgDeleteLink');
        this.editLinks = $('#orgEditLinks');
        this.editForm = $('#orgEditForm');
        this.editName = $('#orgEditName');
        this.editBillingEmail = $('#orgEditBillingEmail');
        this.editVatCountries = $('#orgEditVatCountries');
        this.editVatNumber = $('#orgEditVatNumber');
        this.editError = $('#orgEditError');

        this.deleteConfirm = $('#orgDeleteConfirm');
        this.deleteForm = $('#orgDeleteForm');
        this.deleteError = $('#orgDeleteError');

        this.leaveConfirm = $('#orgLeaveConfirm');
        this.leaveConfirmOnlyAdmin = $('#orgLeaveConfirmOnlyAdmin');
        this.leaveLastFree = $('#orgLeaveLastFree');
        this.leaveForm = $('#orgLeaveForm');
        this.leaveError = $('#orgLeaveError');

        this.connectionsWrapper = $('#orgConnections');
        this.networkDetails = $('#orgDetailConnections');
        this.networkDetailsHead = $('#orgDetailConnectionsHead');
        this.addConnectionsLink = $('#orgAddMoreConnections');
        this.addConnectionsHead = $('#orgAddConnectionsHead');
        this.addConnections = $('#orgAddConnections');
        this.addIrcd = $('#orgAddIrcd');
        this.addMoreLink = $('#orgAddMoreLink');
        this.networkJoinForm = $('#orgJoinConnectionsForm');
        this.networkJoinExplanation = $('#orgConnectionsJoinExplanation');
        this.networkJoinAlready = $('#orgConnectionsJoinAlready');
        this.networkJoinRealName = $('#orgJoinConnectionsRealName');
        this.networkExplanation  = $('.orgConnectionsExplanation');
        this.ircdEditorContainer = $('#orgIrcdEditor');
        this.networkEditorContainer = $('#orgNetworkEditor');
        this.addWithMembers = $('#orgAddWithMembers');

        this.memberManage = $('#orgMembersManage');

        this.addMembersForm = $('form#orgAddMembers');
        this.addMemberError = $('#orgAddMemberError');
        this.addMembersEmail = $('#orgAddMembersEmail');
        new Autogrow({
            el: this.addMembersEmail,
            minHeight: 76
        });
        this.addMemberExplanation = $('#orgAddMemberExplanation');

        this.inviteesTable = $('table#orgInvitees');
        this.inviteesSend = $('#orgInviteesSend');
        this.inviteeViews = [];

        this.membersWrapper = $('#orgMembersWrapper');
        this.membersForm = $('form#orgMembers');
        this.membersSave = $('#orgMembersSave');
        this.membersTable = this.membersForm.find('table.joined');
        this.pendingMembersTable = this.membersForm.find('table.pending');
        this.membersViews = [];

        this.paymentBusinessDetails = $('form#orgPaymentBusinessDetails');
        this.paymentBillingEmail = $('#orgPaymentBillingEmail');
        this.paymentVatHidden = $('#orgPaymentVatHidden');
        this.paymentVatWrapper = $('#orgPaymentVatWrapper');
        this.paymentVatCountries = $('#orgPaymentVatCountries');
        this.paymentVatNumber = $('#orgPaymentVatNumber');
        this.paymentBusinessDetailsError = $('#orgPaymentBusinessDetailsError');
        this.paymentBusinessDetailsButton = $('#orgPaymentBillingConfirm');
    },
    events: _.extend({}, HashDialogView.prototype.events, PayViewMixins.events, {
        'submit #orgAddMembers': 'submitAddMembers',
        'submit #orgMembers': 'submitEditMembers',
        'click .deleteOrg': 'clickDelete',
        'click .leaveOrg': 'clickLeave',
        'click .editOrg': 'clickEdit',
        'submit #orgDeleteForm': 'submitDelete',
        'submit #orgLeaveForm': 'submitLeave',
        'buttonClick #orgDeleteForm .cancel': 'clickCancelDelete',
        'buttonClick #orgLeaveForm .cancel': 'clickCancelLeave',
        'buttonClick #orgLeaveConfirmOnlyAdmin .cancel': 'clickCancelLeave',
        'submit #orgEditForm': 'submitEditForm',
        'buttonClick #orgEditForm .cancel': 'clickCancelEdit',
        'click #orgAddMoreConnections a': 'clickAddMoreConnections',
        'click #orgAddMoreLink a': 'clickAddMoreConnections',
        'click #orgUseCustomConnection a.custom': 'clickUseCustomConnection',
        'click #orgDetailConnections div.networks a.delete': 'clickRemoveConnection',
        'buttonClick #orgRemoveIrcdConfirm .delete': 'clickRemoveIrcd',
        'buttonClick #orgRemoveIrcdConfirm .cancel': 'clickCancelRemoveIrcd',
        'buttonClick #orgInviteesSend': 'clickInviteesSend',
        'submit #orgJoinConnectionsForm': 'submitJoinMissingForm',
        'submit #orgPaymentBusinessDetails': 'submitPaymentBusinessDetails',
        'buttonClick #orgPaymentBillingConfirm': 'submitPaymentBusinessDetails',
        'click #orgPaymentVatHidden a': 'clickPaymentVatShow'
    }),
    render: function (org, billing) {
        if (this.model != org) {
            if (this.model) {
                this.model.members.unbind(null, null, this);
                this.model.invitees.unbind(null, null, this);
                this.model.unbind(null, null, this);
                this.session.unbind(null, null, this);

                this.hideAddMemberError();
                this.editMode(false);
                this.hideEditError();
                this.hideDeleteConfirm();
                this.hideLeaveConfirm();
                $(this.el).removeSpin();
                this.hideDeleteError();
                this.hideLeaveError();
                this.resetPay();
                this.renderPay();
                this.addMembersEmail.val('');
            }

            this.model = org;
            this.model.bind('change', this.renderDetails, this);
            
            this.model.members.bind('reset saved', this.resetMembers, this);
            this.model.members.bind('change removedChange saved', this.renderMembersChanged, this);
            
            this.model.bind('connectionsChange billingUpdate', this.resetConnections, this);
            
            this.model.bind('change connectionsChange billingUpdate', this.updateProgression, this);
            this.model.members.bind('reset saved', this.updateProgression, this);

            this.model.bind('change connectionsChange', this.renderPay, this);

            PayViewMixins.initialize.call(this);

            this.model.invitees.bind('add', this.addMemberToAdd, this);
            this.model.invitees.bind('remove', this.removeInvitees, this);
            this.model.invitees.bind('reset', this.resetInvitees, this);

            this.model.invitees.bind('add remove reset', this.updateAmount, this);
            this.model.members.bind('add remove reset', this.updateAmount, this);
            this.listenTo(this.session, 'plansChange', this.plansChange);

            this.model.invitees.bind('add remove reset', this.renderPay, this);
            this.model.members.bind('add remove reset', this.renderPay, this);

            this.billingLink.attr('href', '/?/team-billing=' + this.model.id);
            this.billingBackLink.attr('href', '/?/team=' + this.model.id);
            this.networkEditor = this.makeEditor();
            this.ircdEditor = this.makeIrcdEditor();
            this.ircdEditorContainer.html(this.ircdEditor.render().el);
            this.networkEditorContainer.html(this.networkEditor.render().el);
            this.networkEditor.renderSelectComplete($(this.dialog.el)); // needs to happen after it's appended to the DOM cos of the shitty plugin
            this.networkEditor.triggerLoad();
        }

        this.renderDetails();
        this.resetConnections();
        this.resetMembers();
        this.resetInvitees();
        this.updateProgression();
        this.updateAmount();
        this.toggleBillingInfo(billing);
        this.renderBackLinks();
        if (this.model.isAdmin()) {
            this.model.getMembers();
        }
    },
    renderBackLinks: function () {
        var onlyOne = this.session.hasOneOrg();
        $('#orgDetailCreateLink').toggle(onlyOne);
        $('#orgDetailListLink').toggle(!onlyOne);
        this.returnLines.show();
    },
    renderDetails: function () {
        this.editLinks.toggle(this.model.isAdmin());
        this.detailVitals.show();
        this.manageLinks.show();
        this.deleteLink.hide();
        this.detailBillingEmailRow.toggle(this.model.isAdmin());
        this.detailName.text(this.model.get('name'));
        this.editName.val(this.model.get('name'));
        this.detailBorn.text(new Date(this.model.get('creation_time') * 1000).toString('dd MMM yyyy'));

        this.detailBillingEmail.text(this.model.get('billing_email'));
        this.editBillingEmail.val(this.model.get('billing_email'));
        this.paymentBillingEmail.val(this.model.get('billing_email'));
        this.detailVatRow.toggleClass('edit', !this.model.get('vat_number'));
        this.detailVatExplanation.toggleClass('edit', !this.model.get('vat_number'));
        this.detailVatCountry.text(this.model.get('vat_country'));
        this.renderVatCountries();
        this.detailVatNumber.text(this.model.get('vat_number'));
        this.editVatNumber.val(this.model.get('vat_number'));
        this.paymentVatNumber.val(this.model.get('vat_number'));
        this.renderBillingDetails();
    },
    clickAddMoreConnections: function (e) {
        e.preventDefault();
        if (this.addConnections.is(':visible') || this.addIrcd.is(':visible')) {
            this.networkExplanation.hide();
            this.addConnections.slideUp('fast');
            this.addIrcd.slideUp('fast');
        } else {
            if (this.model.hasIrcd()) {
                this.clickUseCustomConnection(e);
            } else {
                this.cancelConnections();
            }
        }
    },
    clickUseCustomConnection: function (e) {
        e.preventDefault();
        this.addIrcd.slideUp('fast');
        this.networkExplanation.show();
        this.addConnections.slideDown('fast', _.bind(function () {
            this.networkEditor.focusNetwork();
        }, this));
    },
    clickRemoveConnection: function (e) {
        e.preventDefault();
        var net = $(e.target).closest('div.network');
        var index = net.data('index');
        if (index == 'ircd') {
            $('#orgRemoveIrcdConfirm').slideDown('fast');
        } else {
            net.addClass('removedNetwork');
            this.model.removeNetwork(index, function (response) {
                if (!response.success) {
                    net.removeClass('removedNetwork');
                }
            });
        }
    },
    clickCancelRemoveIrcd: function (e) {
        e.preventDefault();
        $('#orgRemoveIrcdConfirm').slideUp('fast');
    },
    clickRemoveIrcd: function (e) {
        e.preventDefault();
        var net = $(e.target).closest('div.network.ircd');
        net.addClass('removedNetwork');
        $('#orgRemoveIrcdConfirm button.delete').addSpin();
        this.model.removeIrcd(function (response) {
            $('#orgRemoveIrcdConfirm button.delete').removeSpin();
            if (response.success) {
                $('#orgRemoveIrcdConfirm').slideUp('fast');
            } else {
                net.removeClass('removedNetwork');
            }
        });
    },
    submitAddMembers: function (e) {
        e.preventDefault();
        this.hideAddMemberError();
        var data = this.addMembersForm.serializeForm();
        var emails = _.unique(_.filter(data.emails.trim().split(/[\s,]+/), _.identity));
        var toAdd = [];
        var invalids = [];
        _.each(emails, function (email) {
            if (urlUtil.isEmail(email)) {
                var exists = this.model.invitees.find(function (m) {
                    return m.get('email') == email;
                });
                if (exists) {
                    if (exists.isRemoved()) {
                        exists.set(data);
                        exists.setRemoved(false);
                    }
                } else {
                    toAdd.push({email: email});
                }
            } else {
                invalids.push(email);
            }
        }, this);
        if (_.isEmpty(invalids)) {
            this.model.invitees.add(toAdd);
            this.addMembersEmail.val('').trigger('update');
        } else {
            var msg = '<b>Invalid email address';
            if (invalids.length != 1) {
                msg += 'es';
            }
            msg += ':</b><br>';
            msg += _.map(invalids, this.formatter.escapeText).join('<br>');
            this.addMemberError.html(msg).fadeIn('fast');
        }
    },
    hideAddMemberError: function () {
        this.addMemberError.hide();
    },

    resetInvitees: function () {
        _.each(this.inviteeViews, function (memberView) {
            memberView.remove();
        }, this);
        this.inviteeViews = [];
        this.model.invitees.each(function (m) {
            this.addMemberToAdd(m);
        }, this);
        this.inviteesSend.hide();
        if (this.model.invitees.length) {
            this.inviteesTable.fadeIn('fast');
            if (this.model.hasSubscribed()) {
                this.inviteesSend.show();
            }
        } else {
            this.inviteesTable.hide();
        }
    },
    removeInvitees: function () {
        if (!this.model.invitees.length) {
            this.inviteesTable.hide();
            this.inviteesSend.hide();
        }
    },
    addMemberToAdd: function (member) {
        if (this.model.hasSubscribed()) {
            this.inviteesSend.show();
        }
        this.membersTable.show();

        var prevLength = this.inviteeViews.length;
        var view = new OrgMemberView({
            model: member,
            collection: this.model.invitees,
            undoable: false
        });
        this.inviteeViews.push(view);
        this.inviteesTable.append(view.render().el).fadeIn('fast', _.bind(function () {
            if (!prevLength) {
                this.addMembersEmail[0].scrollIntoView();
            }
        }, this));
    },

    plansChange: function () {
        this.updateAmount();
        this.renderVatCountries();
    },
    renderVatVisible: function () {
        var show = this.session.plans.eu_vat.applicable || !!this.model.get('vat_number');
        this.paymentVatHidden.toggle(!show);
        this.paymentVatWrapper.toggle(show);
    },
    renderVatCountries: function () {
        this.paymentVatCountries.html('<option>');
        this.editVatCountries.html('<option>');
        if (this.session.plans.eu_vat) {
            this.renderVatVisible();
            _.each(this.session.plans.eu_vat.countries, function (c) {
                var option = $('<option>').val(c.code).text(c.code + ' - ' + c.name);
                var editOption = option.clone();
                if (c.code === (this.model.get('vat_country') || this.session.plans.vat_country || this.session.plans.country)) {
                    option.prop('selected', true);
                    editOption.prop('selected', true);
                }
                this.paymentVatCountries.append(option);
                this.editVatCountries.append(editOption);
            }, this);
        }
    },
    getUserCount: function () {
        return this.model.invitees.length + this.model.members.length + 1;
    },
    getAmount: function () {
        var userCount = this.getUserCount();
        return userCount * this.dialog.getPerSeat();
    },
    updateAmount: function () {
        var userCount = this.getUserCount();
        this.$('.pay .userCount').text(userCount);
        this.$('.pay .userCountPlural').toggle(userCount != 1);
        this.$('.pay .perUser').text(this.formatter.amount(this.session.getCurrency(), this.dialog.getPerSeat()));
        this.$('.pay .amount').text(this.formatter.amount(this.session.getCurrency(), this.getAmount()));
    },
    clickInviteesSend: function (e) {
        e.preventDefault();
        this.model.inviteMembers();
    },

    updateProgression: function () {
        if (this.model.hasSubscribed()) {
            this.dialog.hideProgression();
        } else if (this.model.hasFetchedMembers()) {
            if (this.model.areConnectionsChosen() || this.model.hasIrcd()) {
                this.dialog.showMembersProgression();
            } else {
                this.dialog.showConnectionsProgression();
            }
        }
    },

    resetMembers: function () {
        _.each(this.membersViews, function (memberView) {
            memberView.remove();
        }, this);
        this.membersViews = [];
        this.membersTable.hide();
        this.pendingMembersTable.hide();
        this.membersWrapper.hide();
        this.addMember(new OrgMember({
            email: this.session.get('email'),
            uid: this.session.id,
            admin: true,
            self: true
        }, {
            org: this.model
        }));
        if (this.model.members.length) {
            this.model.members.each(this.addMember, this);
            this.detailVitals.show();
            this.manageLinks.show();
            this.deleteLink.hide();
        }
        this.membersWrapper.show();
    },
    renderMembersChanged: function () {
        this.membersSave.toggle(this.model.membersNeedSaving());
    },
    addMember: function (member) {
        var view = new OrgMemberView({
            model: member,
            collection: this.model.members
        });
        this.membersViews.push(view);
        if (member.isJoined()) {
            this.membersTable.find('tbody').append(view.render().el);
        } else {
            this.pendingMembersTable.find('tbody').append(view.render().el);
            this.pendingMembersTable.show();
        }
        if (this.membersViews.length > 1) {
            this.membersTable.show();
        }
    },

    submitEditMembers: function (e) {
        e.preventDefault();
        this.membersForm.addSpin();
        this.model.saveMembers(_.bind(function (response) {
            this.membersForm.removeSpin();
        }, this));
    },
    focusAddMemberEmail: function () {
        this.addMembersEmail.focus().select();
    },
    focusEditName: function () {
        this.editName.focus().select();
    },

    // PayViewMixins
    billingCancelSureText: 'Are you sure you want to cancel this team subscription? All your members will revert to personal account limits.',
    formatPlan: function (b) {
        var s = b.quantity != 1 ? 's' : '';
        return this.formatter.escapeText(b.quantity) + ' seat' + s + ' — ' + this.formatter.amount(b.currency, b.amount * b.quantity) + '/month';
    },
    formatSubscriptionInvoiceItem: function (sub) {
        var s = sub.quantity != 1 ? 's' : '';
        return 'Subscription (' + this.formatter.escapeText(sub.quantity) + ' seat' + s + ')';
    },
    stripeCheckout: function (label, callback, options) {
        return PayViewMixins.stripeCheckout.call(this, label, callback, $.extend(true, {}, {
            email: this.model.get('billing_email'),
            currency: this.session.getCurrency(),
            amount: this.getAmount(),
            description: 'Team subscription for ' + this.model.get('name'),
            closed: _.bind(this.updateProgression, this),
            org: this.model.id,
            subscription: true
        }, options));
    },
    doPayment: function () {
        var currency = this.session.getCurrency();
        this.stripeCheckout(
            'Setup subscription',
            _.bind(function (data, mixinCallback) {
                if (data) {
                    data.currency = currency;
                    data.seats = 1;
                    this.model.subscribe(data, _.bind(function (response) {
                        if (response.success) {
                            this.model.inviteMembers();
                            this.connectionsWrapper.slideUp('fast');
                            this.memberManage.slideUp('fast');
                        }
                        mixinCallback(response);
                    }, this));
                }
            }, this)
        );
    },
    clickPayButton: function (e) {
        e.preventDefault();
        this.doPayment();
    },

    renderPayNoActiveSub: function () {
        if (this.model.hasSubscribed() || this.model.areConnectionsChosen() || this.model.hasIrcd()) {
            PayViewMixins.renderPayNoActiveSub.call(this);
            this.paymentBusinessDetails.show();
            this.dialog.benefits.show();
        }
    },
    renderPayCanSeeSubscription: function () {
        this.addMemberExplanation.toggle(!this.model.hasSubscribed());
        PayViewMixins.renderPayCanSeeSubscription.call(this);
    },
    resetPay: function () {
        this.hidePayError();
        this.$('.payStatus').hide();
        this.$('.payComplete').hide();
    },
    renderPay: function () {
        this.paymentBusinessDetails.hide();
        this.dialog.benefits.hide();
        this.renderBackLinks();
        PayViewMixins.renderPay.call(this);
    },
    renderBillingDetails: function () {
        var contents = this.formatBillingDetails();
        contents.find('.subscriptionStatus').append($('#tpl-org-billing-pay-status').html());
        contents.find('.payMonthlyNew .payButtonWrapper').append($('#tpl-org-billing-pay-footer').html());
        this.billingDetails.html(contents);
        this.updateAmount();
    },

    resetConnections: function (options) {
        var chosen = this.model.areConnectionsChosen();
        var peeps = this.model.hasMembersOrInvitees();
        var subbed = this.model.hasSubscribed();
        var hasIrcd = this.model.hasIrcd();

        // Only show members if connections have been chosen or skipped
        this.connectionsWrapper.show();
        this.addConnections.hide();
        if (!this.model.isAdmin()) {
            this.memberManage.hide();
            this.addIrcd.hide();
            this.addConnectionsHead.hide();
            this.networkExplanation.hide();
            this.addMoreLink.hide();
        } else {
            this.detailVitals.toggle(chosen && (subbed || peeps));
            this.manageLinks.toggle(chosen && (subbed || peeps));
            this.deleteLink.toggle(chosen && !(subbed || peeps));
            this.memberManage.toggle(chosen);
            this.addWithMembers.toggle(subbed);
            this.addConnectionsHead.toggle(!chosen);
            if (chosen) {
                this.ircdEditor.setCancelLabel('Cancel');
                this.networkEditor.setSubmitLabel("Add Channels");
            }

            this.networkExplanation.toggle(!chosen || hasIrcd || this.model.hasConnections());
            this.addMoreLink.toggle(hasIrcd || this.model.hasConnections());

            this.addIrcd.toggle(!chosen);

            // Reset editors
            this.ircdEditor.setAutoChannels('');
            this.networkEditor.setHostname('');
            this.networkEditor.setPort(Connection.defaultPort);
            this.networkEditor.setSSL();
            this.networkEditor.setAutoChannels('');
            this.networkEditor.setServerPassword('');
        }
        this.networkJoinAlready.hide();
        this.networkJoinExplanation.hide();
        this.networkJoinForm.data('org', this.model.id);
        if (this.model.hasConnections() || hasIrcd) {
            var nets = this.networkDetails.find('div.networks');
            var lines = _.map(this.model.connections, function (c, i) {
                return this.dialog.renderConnection(c, i, this.model.isAdmin(), this.model);
            }, this);
            if (hasIrcd) {
                lines.unshift(this.dialog.renderConnection(this.model.getIrcdConnection(), 'ircd', this.model.isAdmin(), this.model));
            }
            nets.html('').append(lines);

            this.networkJoinRealName.val(this.model.session.get('name'));
            if (nets.find('a.chan, .matchConnChoiceExplanation').length) {
                this.networkJoinExplanation.show();
                this.networkJoinExplanation.find('.connections').hide();
                this.networkJoinExplanation.find('.passwords').hide();
                this.networkJoinExplanation.find('.both').hide();
                this.networkJoinExplanation.find('.update').hide();
                if (nets.find('a.chan').length) {
                    this.networkJoinExplanation.find('.connections').show();
                }
                if (nets.find('.matchConnChoiceExplanation').length) {
                    if (nets.find('.matchConnChoiceExplanation.password').length) {
                        this.networkJoinExplanation.find('.passwords').show();
                        if (nets.find('a.chan').length) {
                            this.networkJoinExplanation.find('button span.connections').hide();
                            this.networkJoinExplanation.find('button span.passwords').hide();
                            this.networkJoinExplanation.find('button span.both').show();
                        }
                    } else {
                        this.networkJoinExplanation.find('.connections').show();
                    }
                }
                if (nets.find('strong.chan').length) {
                    this.networkJoinAlready.show();
                }
            }

            this.networkDetails.find('.edit').show();
            this.networkDetails.show();
            this.networkDetailsHead.show();
            this.addConnectionsLink.hide();
        } else {
            this.networkDetails.hide();
            this.networkDetailsHead.hide();
            this.addConnectionsLink.toggle(this.model.isAdmin() && chosen);
        }
    },
    cancelConnections: function () {
        if (!this.model.hasIrcd()) {
            this.networkExplanation.show();
            this.addMoreLink.hide();
            this.addIrcd.slideDown('fast', _.bind(function () {
                this.ircdEditor.focusChannels();
            }, this));
        }
        this.addConnections.slideUp('fast');
    },
    skipConnections: function () {
        if (!this.model.areConnectionsChosen()) {
            this.model.saveConnections();
        }
        this.addConnectionsHead.hide();
        this.addIrcd.slideUp('fast', _.bind(function () {
            this.addMoreLink.show();
        }, this));
        this.addConnections.slideUp('fast', _.bind(function () {
            if (!this.model.hasConnections()) {
                this.addConnectionsLink.show();
                this.networkExplanation.hide();
            }
            this.ircdEditor.setCancelLabel('Cancel');
            this.networkEditor.setSubmitLabel("Add Channels");
        }, this));
    },
    makeIrcdEditor: function () {
        var idPrefix = "orgAddIrcdChannel";
        return new NetworkEditor({
            model: this.model,
            session: this.session,
            action: _.bind(this.model.addIrcd, this.model),
            callback: _.bind(function (response) {
                if (response.success) {
                    if (this.model.hasSubscribed() && !response.cid) {
                        this.dialog.hide();
                    }
                }
            }, this),
            className: 'addNetworkForm orgAddChannel',
            classPrefix: "addNetwork",
            id: idPrefix + 'Form',
            idPrefix: idPrefix,
            submitLabel: "Continue",
            cancelLabel: "Skip",
            tabFocus: 'Channels',
            cancel: _.bind(this.skipConnections, this),
            cellGroups: [
                {
                    heading: false,
                    cells: [{
                        row: true,
                        optional: true,
                        inputElement: "textarea",
                        inputClass: "Channels",
                        inputAttrs: {
                            name: "channels",
                            rows: 4,
                            placeholder: "e.g. #general, #offtopic (comma, space, or line separated)"
                        }
                    }]
                }
            ]
        }, this);
    },
    makeEditor: function () {
        var idPrefix = "orgAddChannel";
        return new NetworkEditor({
            model: this.model,
            session: this.session,
            action: _.bind(this.model.addNetwork, this.model),
            callback: _.bind(function (response) {
                if (response.success) {
                    if (this.model.hasSubscribed() && (!response.cids || !response.cids[0])) {
                        this.dialog.hide();
                    }
                }
            }, this),
            className: 'addNetworkForm orgAddChannel',
            classPrefix: "addNetwork",
            id: idPrefix + 'Form',
            idPrefix: idPrefix,
            submitLabel: "Continue",
            cancelLabel: "Cancel",
            tabFocus: 'Channels',
            cancel: _.bind(this.cancelConnections, this),
            cellGroups: [
                NetworkEditor.CELL_GROUPS.network,
                {
                    heading: false,
                    cells: [NetworkEditor.CELLS.channels, NetworkEditor.CELLS.serverPass]
                }
            ]
        }, this);
    },

    show: function (org, billing) {
        billing = !!billing;
        this.render(org, billing);
        if (!this.visible) {
            $(this.el).show();
            this.returnLines.show();
            this.visible = true;
        }
        return this;
    },
    hide: function () {
        if (this.visible) {
            $(this.el).hide();
            this.returnLines.hide();
            this.visible = false;
        }
        return this;
    },
    isVisible: function () {
        return this.visible;
    },
    isBillingShown: function () {
        return this.billingShown;
    },
    clickDelete: function (e) {
        e.preventDefault();
        this.showDeleteConfirm();
    },
    clickLeave: function (e) {
        e.preventDefault();
        this.showLeaveConfirm();
    },
    clickCancelDelete: function (e) {
        e.preventDefault();
        this.hideDeleteError();
        this.hideDeleteConfirm();
    },
    clickCancelLeave: function (e) {
        e.preventDefault();
        this.hideLeaveError();
        this.hideLeaveConfirm();
    },
    showDeleteConfirm: function () {
        this.deleteConfirm.fadeIn('fast');
    },
    showLeaveConfirm: function () {
        this.leaveLastFree.toggle(this.session.hasOneOrg() && !this.session.hasActiveSubscription());
        if (this.model.isOnlyAdmin()) {
            this.leaveConfirmOnlyAdmin.fadeIn('fast');
        } else {
            this.leaveConfirm.fadeIn('fast');
        }
    },
    hideDeleteConfirm: function () {
        this.deleteConfirm.hide();
    },
    hideLeaveConfirm: function () {
        this.leaveConfirmOnlyAdmin.hide();
        this.leaveConfirm.hide();
    },
    showDeleteError: function (text) {
        this.deleteError.text(text).fadeIn('fast');
    },
    showLeaveError: function (text) {
        this.leaveError.text(text).fadeIn('fast');
    },
    hideDeleteError: function () {
        this.deleteError.hide();
    },
    hideLeaveError: function () {
        this.leaveError.hide();
    },
    submitDelete: function (e) {
        e.preventDefault();
        this.deleteForm.addSpin();
        this.model.remove(_.bind(function (response) {
            this.deleteForm.removeSpin();
            if (!response.success) {
                this.showDeleteError('There was a problem deleting this team: ' + response.message);
            }
        }, this));
    },
    submitLeave: function (e) {
        e.preventDefault();
        this.leaveForm.addSpin();
        this.model.leave(_.bind(function (response) {
            this.leaveForm.removeSpin();
            if (!response.success) {
                var msg;
                switch (response.message) {
                case 'last_admin_cant_leave':
                    msg = 'You can’t leave this team as the last admin. Did you mean to delete it instead?';
                    break;
                default:
                    msg = 'There was a problem leaving this team: ' + response.message;
                }
                this.showLeaveError(msg);
            }
        }, this));
    },
    toggleBillingInfo: function (show) {
        // TODO rely on fetch working to show
        this.billingInfo.addClass('isLoadingBilling');
        // TODO hide previous billing errors
        if (this.model.isAdmin()) {
            this.model.getBillingInfo(_.bind(function () {
                this.billingInfo.removeClass('isLoadingBilling');
            }, this));
        }
        this.billingInfo.toggle(show);
        this.details.toggle(!show);
        this.billingShown = show;
    },
    editMode: function (toggle) {
        if (toggle === undefined) {
            this.$('.edit').toggle();
            this.$('.editDetail').toggle();
        } else {
            this.$('.edit').toggle(toggle);
            this.$('.editDetail').toggle(!toggle);
        }
        if (this.$('.edit').is(':visible')) {
            this.focusEditName();
        }
    },
    hideEditError: function () {
        this.editError.hide();
    },
    showEditError: function (text) {
        this.editError.text(text).fadeIn('fast');
    },
    hidePaymentBusinessDetailsError: function () {
        this.paymentBusinessDetailsError.hide();
    },
    showPaymentBusinessDetailsError: function (text) {
        this.paymentBusinessDetailsError.text(text).fadeIn('fast');
    },
    clickEdit: function (e) {
        e.preventDefault();
        this.editMode();
    },
    clickCancelEdit: function (e) {
        e.preventDefault();
        this.editMode(false);
    },
    clickPaymentVatShow: function (e) {
        e.preventDefault();
        this.paymentVatHidden.hide();
        this.paymentVatWrapper.slideDown('fast', _.bind(function () {
            this.paymentVatNumber.select().focus();
        }, this));
    },
    submitEditForm: function (e) {
        e.preventDefault();
        var data = this.editForm.serializeForm();
        this.hideEditError();
        this.doEdit(data, _.bind(function (response, errorMessage) {
            if (response.success) {
                this.editMode(false);
            } else {
                this.showEditError(errorMessage);
            }
        }, this));
    },
    submitPaymentBusinessDetails: function (e) {
        this.paymentBusinessDetailsButton.addSpin();
        e.preventDefault();
        var data = this.paymentBusinessDetails.serializeForm();
        this.hidePaymentBusinessDetailsError();
        this.doEdit(data, _.bind(function (response, errorMessage) {
            this.paymentBusinessDetailsButton.removeSpin();
            if (response.success) {
                if (!this.model.hasSubscribed()) {
                    this.dialog.showPaymentProgression();
                }
                this.doPayment();
            } else {
                this.showPaymentBusinessDetailsError(errorMessage);
            }
        }, this));

    },
    doEdit: function (data, callback) {
        this.model.edit(data, _.bind(function (response) {
            if (response.success) {
                callback(response);
            } else {
                var message = "";
                switch (response.message) {
                case "missing_name":
                    message = "Missing team name";
                    break;
                case "missing_billing_email":
                    message = "Missing billing email";
                    break;
                case 'invalid_billing_email':
                    message = 'Invalid billing email';
                    break;
                case 'server_error':
                    message = 'There was a problem editing this team';
                    break;
                case 'invalid_vat_country':
                    message = 'Invalid VAT number country';
                    break;
                case 'invalid_vat_number':
                    message = 'Invalid VAT number — you must be registered for VAT in the European union';
                    break;
                case 'error_verifying_vat':
                    message = 'Error validating your VAT number, please try again';
                    break;
                default:
                    message = 'There was a problem editing this team: ' + response.message;
                    break;
                }
                callback(response, message);
            }
        }, this));
    },
    submitJoinMissingForm: function (e) {
        e.preventDefault();
        var form = $(e.currentTarget);
        var data = form.serializeForm();
        var chosen = this.dialog.getChosenConns(this.networkJoinForm, this.model, data);
        data.connections = JSON.stringify(chosen);
        form.find('.userError').hide();
        form.addSpin();
        this.model.joinConnections(data, _.bind(function (response) {
            form.removeSpin();
            if (response.success) {
                if (response.cids && response.cids[0]) {
                    this.session.setFocusOnMakeServer(response.cids[0]);
                } else {
                    this.dialog.hide();
                }
            } else {
                this.showJoinConnectionError(form, response);
            }
        }, this));
    },
    showJoinConnectionError: function (form, response) {
        var msg;
        switch (response.message) {
        case "missing_nickname":
            msg = "Missing nickname";
            break;
        case "invalid_nickname":
            msg = "Invalid nickname";
            break;
        default:
            msg = "Error: " + response.message;
            break;
        }
        form.find('.userError').html(msg).fadeIn('fast');
    }
}));

module.exports = OrgDetailView;



//////////////////
// WEBPACK FOOTER
// ./app/src/view/model/orgdetailview.js
// module id = oMKX
// module chunks = 1